exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p { color: hotpink; }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/homePC/angular-comp/yarukami/src/app/top/completed/completed.component.css
// module id = ../../../../../src/app/top/completed/completed.component.css
// module chunks = main